import { Modal } from "antd";
import { displayMessage } from "../../services/helper";
import api from "../../services/api";
import { useEffect, useState, useContext } from "react";
import GeneralContext from "../../context/GeneralContext/GeneralContext";
const ListPatientExerciseProtocolModal = ({
  isPatientProtocolModalOpen,
  setIsPatientProtocolModalOpen,
  selectedRow,
}) => {
  const [exercises, setExercises] = useState([]);
  const { setShowLoading } = useContext(GeneralContext);
  const loadExercisesProtocol = async () => {
    setShowLoading(true);
    try {
      const { data } = await api.exercise_protocol.getExercisesByProtocol(
        selectedRow.protocolId
      );
      setExercises(data);
    } catch (error) {
      console.error(error);
    } finally {
      setShowLoading(false);
    }
  };
  useEffect(() => {
    loadExercisesProtocol();
  }, []);
  return (
    <Modal
      footer={null}
      visible={isPatientProtocolModalOpen}
      onCancel={() => setIsPatientProtocolModalOpen(false)}
      title={
        <div className="text-xl font-bold text-appian-blue">
          {displayMessage("LIST_PATIENT_PROTOCOL_EXERCISE")}
        </div>
      }
    >
      <div>
        {exercises.map((exercise) => (
          <div
            key={exercise.id}
            className="mb-2.5 p-2.5 border border-gray-300"
          >
            <div>
              <strong>{displayMessage("NAME")}:</strong> {exercise.name}
            </div>
            <div>
              <strong>{displayMessage("DESCRIPTION")}:</strong>{" "}
              {exercise.description}
            </div>
            <div>
              <strong>{displayMessage("REPETITIONS")}:</strong>{" "}
              {exercise.videoRepeatCount}
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};
export default ListPatientExerciseProtocolModal;
